import React from 'react';
import {withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow} from "react-google-maps";
import {marker} from "../../../constants/asseturls";
import {compose, withStateHandlers} from "recompose";
import {googleMapStyles} from "../../../constants/googleMaps";
import {getUnitElevation, getUnitLatitude, getUnitLongitude, getUnitName} from "../utils";

/**
 * A component that displays the map near a current unit
 */
const UnitMap = (props) => {
    return (
        <GoogleMap
            defaultZoom={12}
            defaultOptions={{styles: googleMapStyles}}
            center={{ lat: getUnitLatitude(props.selectedUnit), lng: getUnitLongitude(props.selectedUnit)}}
        >
            <Marker
                position={{ lat: getUnitLatitude(props.selectedUnit), lng: getUnitLongitude(props.selectedUnit) }}
                options={{icon: marker}}
                onMouseOver={props.onHover}
                onMouseOut={props.onHoverExit}
                onClick={props.onClick}
            >
                {
                    props.isInfoWindowOpen &&
                    <InfoWindow onCloseClick={props.onCloseClick}>
                        <div className="infoWindow">
                            <h6>{getUnitName(props.selectedUnit)}</h6>
                            <div className="text-small">Lat: {getUnitLatitude(props.selectedUnit)}</div>
                            <div className="text-small">Long: {getUnitLongitude(props.selectedUnit)}</div>
                            {
                                getUnitElevation(props.selectedUnit) &&
                                <div className="text-small">Elevation: {getUnitElevation(props.selectedUnit)}m</div>
                            }
                        </div>
                    </InfoWindow>
                }
            </Marker>
        </GoogleMap>
    );
};

export default compose(
    withStateHandlers(
        () => ({isInfoWindowOpen: false, isClicked: false}),
        {
            onHover: ({isOpen}) => () => ({isInfoWindowOpen: true}),
            onHoverExit: ({isOpen, isClicked}) => () => (!isClicked && {isInfoWindowOpen: false}),
            onClick: ({isOpen, isClicked}) => () => ({isInfoWindowOpen: true, isClicked: !isClicked}),
            onCloseClick: ({isOpen, isClicked}) => () => ({isInfoWindowOpen: false, isClicked: false})
        }),
    withScriptjs,
    withGoogleMap
)(UnitMap);



// WEBPACK FOOTER //
// ./src/components/unit/livegps/UnitMap.jsx